import { forwardRef, useEffect, useMemo, useImperativeHandle } from 'react';
import { createPortal } from 'react-dom';

export interface PortalProps {
	attach?: HTMLElement | string;
	children: React.ReactNode;
	className: string;
}
// 接收 attach、children 参数，attach 就是挂载到的 dom 节点，默认是 document.body
const Portal = forwardRef((props: PortalProps, ref) => {
	const { attach = document.body, children, className } = props;
	//  attach 的元素下添加一个 dom 节点作为容器：
	const container = useMemo(() => {
		const el = document.createElement('div');
		el.className = className;
		return el;
	}, []);

	useEffect(() => {
		const parentElement = getAttach(attach);
		parentElement?.appendChild?.(container);

		return () => {
			parentElement?.removeChild?.(container);
		};
	}, [container, attach]);

	useImperativeHandle(ref, () => container);

	return createPortal(children, container);
});

export default Portal;
// 如果传入的是 string，就作为选择器来找到对应的 dom，如果是 HTMLElement，则直接作为挂载节点，否则，返回 document.body：
export function getAttach(attach: PortalProps['attach']) {
	if (typeof attach === 'string') {
		return document.querySelector(attach);
	}
	if (typeof attach === 'object' && attach instanceof window.HTMLElement) {
		return attach;
	}

	return document.body;
}
